import { ListItemText, styled } from '@mui/material';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router';
import { useChatActionBarUIState } from 'src/features/ActionsBar/Add/useChatActionBarUIState';
import { useChatUnreadState } from 'src/features/ActionsBar/Chat/useChatUnreadState';
import { useActionBarState } from 'src/features/ActionsBar/useActionBarState';
import { NavActionButton } from 'src/features/Navbar/NavActionButton/NavActionButton';
import { MenuItemStyled, StyledIcon } from 'src/features/Navbar/NavItem/styles';
import { UserRecent } from 'src/hooks/recents';
import { useChatContext } from 'src/provider/ChatContext';
import { useSelector } from 'src/redux/store';
import { useRecentRegister } from 'src/sections/@dashboard/recents/shared';
import { getCurrentSection } from 'src/state';
import { NavRecentItemIcon } from './NavRecentItemIcon';

type NavRecentItemProps = {
  recent: UserRecent;
};

export const NavRecentChatItem = ({ recent }: NavRecentItemProps) => {
  const { removeRecent, addRecent } = useRecentRegister();
  const { conversationKey = '', rootConversationKey = '' } = useParams();
  const location = useLocation();

  const { setOpenAction } = useActionBarState();
  const { currentActiveChat, setCurrentActiveChat, setIsDrawer } =
    useChatContext();
  const { chatIDList } = useChatActionBarUIState();
  const { chatList, addChatToList } = useChatUnreadState();

  const channelsMap = useSelector((state) => state.chat.conversations.byId);

  const currentLocation = useMemo(
    () => getCurrentSection(location.pathname),
    [location.pathname],
  );

  const handleOpenConversation = () => {
    if (recent.priority) {
      addRecent(recent);
    }

    if (
      (conversationKey === recent.objectRef ||
        rootConversationKey === recent.objectRef) &&
      currentLocation === 'communicate'
    )
      return;

    const chatId = recent.priority ? recent._id : (recent.objectRef as string);
    setCurrentActiveChat(chatId || '');
    setIsDrawer(true);
    setOpenAction('chat');

    if (!chatId || !!chatList[chatId] || chatIDList.includes(chatId)) return;
    addChatToList(channelsMap[chatId]);
  };

  return (
    <>
      <MenuItemStyled
        dense
        depth={1}
        sx={{ mb: '0 !important' }}
        onClick={handleOpenConversation}
        selected={currentActiveChat === recent._id}
      >
        <StyledIcon>
          <NavRecentItemIcon recent={recent} />
        </StyledIcon>
        <StyledText secondary={recent.title} />
        {recent.priority ? (
          <div className={classNames({ highlight: true })}>
            {recent.priority > 9 ? '+9' : recent.priority}
          </div>
        ) : (
          <NavActionButton
            icon="ic:round-close"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              removeRecent(recent._id);
            }}
            size={16}
            color="default"
          />
        )}
      </MenuItemStyled>
    </>
  );
};

export const StyledText = styled(ListItemText)({
  p: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
